export default {
    name : 'wcLabels',

    _selector : ".woocommerce-form-row input, .woocommerce-form-row textarea",

    init()
    {
        this.run();
    },
    run ()
    {
        this.blurFields();
        this.initLabels();
    },

    initLabels()
    {
        const fields = document.querySelectorAll(this._selector);

        fields.forEach((field) => {
            field.addEventListener('focus', this.toggleLabel);
            }
        );

        fields.forEach((field) => {
                field.addEventListener('blur', this.blurFields.bind(this));
            }
        );
    },

    toggleLabel(event)
    {
        const formRow = this.closest(".woocommerce-form-row");
        formRow.classList.add('active');
    },

    blurFields()
    {
        const fields = document.querySelectorAll(this._selector);
        fields.forEach((field) => {
                let formRow = field.closest(".woocommerce-form-row");

                if (!field.value && field !== document.activeElement && field.type!=='password' && field.type!=='checkbox'&& field.type!=='hidden') {
                    formRow.classList.remove('active');

                } else {
                    formRow.classList.add('active');
                }
            }
        );
    },



}